import React from 'react'
import NavigationLayout from 'layouts/Navigation'
import Layout from './layout'

const WhySell = ({
  layout,
}: Record<string, any>): React.ReactElement<React.ComponentProps<any>, any> => (
  <NavigationLayout dataApp='why-sell'>
    <Layout layout={layout} />
  </NavigationLayout>
)

export default WhySell